import React from 'react';

const CharBtn = (props) => (
    <div 
        id={props.id} 
        className="char-btn"
    >
    </div>
);

export default CharBtn;



// WEBPACK FOOTER //
// ./src/components/sections/shared/CharBtn.js